import React from "react";

export default function Button({content, type, size, link = "", action = () => 0, goToNewPage = true}) {
	// 	It's a button with an action
	if (link === "")
		return (
			<button className={`button ${type}-button ${size}-button`} onClick={action}>
				{content}
			</button>
		);
	// It's a link
	else
		if (goToNewPage)
			return(
				<a href={link} className={`button ${type}-button ${size}-button`} target={"_blank"} rel={"noreferrer"}>
					{content}
				</a>
			);
		else
			return(
				<a href={link} className={`button ${type}-button ${size}-button`}>
					{content}
				</a>
			);
}
